//员工资料路由，外部地址
const staffRouter = [{
		path: "/extra/staff/login",
		name: "staffLogin",
		component: () => import("@/views/staff/login"),
		hidden: true,
		meta: {
			title: "员工资料表"
		}
	}, {
		path: "/extra/staff/info",
		name: "staffInfo",
		component: () => import("@/views/staff/info"),
		hidden: true,
		meta: {
			title: "员工资料表"
		}
	},
	{
		path: "/extra/staff/tips",
		name: "staffTips",
		component: () => import("@/views/staff/tips"),
		hidden: true,
		meta: {
			title: "提示信息"
		}
	}
];

export default staffRouter;